import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { encryptedStorage } from 'src/utils/storage'
import {
  WorkflowTypeDefaultApprover,
  WorkflowTypeDefaultViewer,
} from 'src/services/types'

export type WorkflowType = {
  Id: string
  Description: string
  DefaultComments: string
  CountryName: string
  DelegateUser: boolean
  PrivateUser: boolean
  CompanyId: string
  CompanyCode: string
  CompanyName: string
  IsActive: boolean
  StatusDescription: string
  DefaultApprovers?: WorkflowTypeDefaultApprover[]
  DefaultViewers?: WorkflowTypeDefaultViewer[]
}

type WorkflowTypeStore = {
  workflowTypes: WorkflowType[]
  resetWorkflowTypes: () => void
  setWorkflowType: (workflowType: WorkflowType[]) => void
  updateWorkflowTypeStored: (workflowType: WorkflowType) => void
  findWorkflowTypeById: (id: string) => WorkflowType | undefined
}

export const useWorkflowTypeStore = create<WorkflowTypeStore>()(
  persist(
    (set, get) => ({
      workflowTypes: [],
      resetWorkflowTypes: () => set(() => ({ workflowTypes: [] })),
      setWorkflowType: (workflowTypes: WorkflowType[]) =>
        set(() => ({ workflowTypes })),
      findWorkflowTypeById: (id: string) => {
        const { workflowTypes } = get()
        return workflowTypes.find(
          (workflowType: WorkflowType) => workflowType.Id === id
        )
      },
      updateWorkflowTypeStored: (workflowType: WorkflowType) =>
        set((state) => ({
          workflowTypes: state.workflowTypes.map((el) => {
            if (el.Id === workflowType.Id) {
              return workflowType
            }
            return el
          }),
        })),
    }),
    {
      name: 'workflow-types-storage',
      storage: encryptedStorage(),
    }
  )
)
